import { ApiService } from '../../services/api.service';
import { AuthenticationService } from '../../services/authentication.service';
import { TemplateService } from '../../services/template.service';
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import { CALENDAR_LOCALE } from '../../services/constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubSink } from 'subsink';
import { finalize } from 'rxjs/operators';
var PERCENT_EXTRA_CC_EMAIL = [
    'ubonwan@chod.co.th', 'natha@chod.co.th', 'residence@chod.co.th', 'sasithorn@chod.co.th',
];
var SearchComponent = (function () {
    function SearchComponent(apiService, authService, modalService, template) {
        this.apiService = apiService;
        this.authService = authService;
        this.modalService = modalService;
        this.template = template;
        this.itemsPerPage = 40;
        this.allBranch = true;
        this.allDocType = true;
        this.allBranchList = null;
        this.branchList = null;
        this.docTypeList = null;
        this.allDocumentType = [];
        this.allBranchSelected = [];
        this.startDate = null;
        this.endDate = null;
        this.totalItems = 0;
        this.selectedValues = [];
        this.currentPage = 1;
        this.checked = false;
        this.loading = false;
        this.loadingZip = false;
        this.errorMsg = '';
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.loading_all_zip = false;
        this.cancel_loading_all_zip = false;
        this.loading_all_zip_message = '';
        this.resendEmailSmsMessage = '';
        this.isLoadingMessage = '';
        this.isSending = false;
        this.loading_all_zip_progress = 0;
        this.tableArray = [];
        this.allZipCurrent = 0;
        this.canDownloadXml = false;
        this.canDeleteInvoice = false;
        this.canDeleteTaxDocument = false;
        this.canSendEmail = false;
        this.countOther = 0;
        this.countNonOther = 0;
        this.canSendEmailSMS = false;
        this.canDownloadCSV = false;
        this.commentList = [];
        this.showResult = false;
        this.newComment = '';
        this.owner = localStorage.username;
        this.taxId = null;
        this.currentComment = null;
        this.statusSearch = null;
        this.locationSearch = [];
        this.overdueStatusSearch = [];
        this.isResend = false;
        this.resendFirst = false;
        this.resendSecond = false;
        this.buyerEmail = [{ value: '' }];
        this.buyerEmailCheckList = [];
        this.canResendFirst = false;
        this.canResendSecond = false;
        this.resendFirstNotify = false;
        this.resendSecondNotify = false;
        this.firstEmailNotify = false;
        this.firstSmsNotify = false;
        this.secondEmailNotify = false;
        this.secondSmsNotify = false;
        this.canDownloadInvoicePdf = false;
        this.paymentType = [];
        this.additionalDownloadPdf = null;
        this.isLoadingMessageResend = '';
        this.isLoadingCsv = false;
        this.loadingCsvMessage = '';
        this.countCsvFile = null;
        this.commentDeleteType = 'trash-icon';
        this.invoiceDeleteType = 'invoice-delete';
        this.photo = '../../../assets/images/icons/person-placeholder.png';
        this.tableCol = [
            { field: 'invoice_number', header: 'เลขที่เอกสาร' },
            { field: 'buyer_name', header: 'ชื่อลูกค้า' },
            { field: 'reference_ref_location', header: 'Location' },
            { field: 'header_issue_date', header: 'วันที่ออกเอกสาร' },
            // {field: 'branch', header: 'ชื่อสาขา'},
            { field: 'rd_doc_type', header: 'ประเภทเอกสาร' },
            // { field: 'buyer_name', header: 'ชื่อผู้ซื้อ' },
            { field: 'receipt_no', header: 'เลขที่ Receipt No.' },
            { field: 'total_items_total_payment', header: 'ยอดขาย' },
            { field: 'additional_data.status', header: 'สถานะ' },
            { field: 'additional_data.overdue_balance', header: 'ยอดเงินคงค้าง' },
            { field: 'additional_data.due_date_diff', header: 'จำนวนวันที่ค้างชำระ' },
            { field: 'additional_data.overdue_status', header: 'สถานะ' },
            { field: '', header: 'การแจ้งเตือน' },
            {
                field: 'additional_data.first_email_notified'
                    && 'additional_data.first_sms_notified', header: 'แจ้งเตือนครั้งที่ 1'
            },
            {
                field: 'additional_data.second_email_notified'
                    && 'additional_data.second_sms_notified', header: 'แจ้งเตือนครั้งที่ 2'
            },
            { field: '', header: 'กล่องข้อความ' },
        ];
        this.ccEmail = [
            { ccEmailList: 'pirada@chod.co.th' }
        ];
        this.ccEmailcheckList = [];
        this.statusChoices = [
            { label: 'ชำระครบหมดแล้ว', value: 'full_payment' },
            { label: 'ค้างชำระเต็มจำนวน', value: 'full_amount_owed' },
            { label: 'ชำระแล้วบางส่วน', value: 'partial_payment' },
            { label: 'ไม่มีการแสดงสถานะ', value: 'cancelled' },
        ];
        this.statusDropdownChoices = [
            { label: 'ค้างชำระเต็มจำนวน', value: 'full_amount_owed' },
            { label: 'ชำระแล้วบางส่วน', value: 'partial_payment' },
            { label: 'ชำระครบหมดแล้ว', value: 'full_payment' },
        ];
        this.subs = new SubSink();
    }
    SearchComponent.prototype.ngOnInit = function () {
        this.loadInput();
        // this.loadDropdown();
        this.rdDocumentType = this.template.getDropdown();
    };
    SearchComponent.prototype.loadInput = function () {
        var _this = this;
        this.company = [
            {
                label: 'ทั้งหมด',
                value: null
            }
        ];
        this.subs.add(this.apiService.getCompany().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name,
                    value: obj.id
                });
            });
        }));
        this.homeproGroup = [
            {
                label: 'ทั้งหมด',
                value: null
            }
        ];
        this.subs.add(this.apiService.getCompanyGroup().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.homeproGroup.push({
                    label: obj.name,
                    value: obj.id
                });
            });
        }));
        // this.subs.add(
        //   this.apiService.getBranch().subscribe(result => {
        //     this.allBranchList = result;
        //     this.filterBranchList();
        //   })
        // );
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.dropdownStatus();
    };
    Object.defineProperty(SearchComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = new Date().getFullYear();
            return thisYear - 40 + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    // filterBranchList() {
    //   this.selectedBranch = null;
    //
    //   this.branchList = [
    //     {
    //       label: 'ทั้งหมด',
    //       value: null
    //     }
    //   ];
    //
    //   _.forEach(this.allBranchList, obj => {
    //     if (this.selectedCompany == null || obj.corporate === this.selectedCompany) {
    //       this.branchList.push({
    //         label: obj.full_name,
    //         value: obj.id
    //       });
    //     }
    //   });
    // }
    SearchComponent.prototype.searchBranch = function (event) {
        var _this = this;
        if (this.branchList == null) {
            this.subs.add(this.apiService.getBranch().subscribe(function (data) {
                _this.branchList = data;
                _this.branchSuggest = _this.filterData(event.query, 'full_name', _this.branchList);
            }));
        }
        else {
            this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
        }
    };
    SearchComponent.prototype.searchDocumentType = function (event) {
        var _this = this;
        if (this.docTypeList == null) {
            this.subs.add(this.apiService.getDocumentType().subscribe(function (result) {
                _this.docTypeList = result;
                _this.typeSuggest = _this.filterData(event.query, 'type', _this.docTypeList);
            }));
        }
        else {
            this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
        }
    };
    SearchComponent.prototype.selectAllBranch = function () {
        this.branch = null;
    };
    SearchComponent.prototype.selectDocType = function () {
        this.documentType = null;
    };
    SearchComponent.prototype.clearBranch = function () {
        this.allBranchSelected = [];
    };
    SearchComponent.prototype.clearDocType = function () {
        this.allDocumentType = [];
    };
    SearchComponent.prototype.filterData = function (query, field, dataList) {
        query = query.toLowerCase().trim();
        var filtered = [];
        for (var i = 0; i < dataList.length; i++) {
            var data = dataList[i];
            if (data[field].toLowerCase().indexOf(query) >= 0) {
                filtered.push(data);
            }
        }
        return filtered;
    };
    SearchComponent.prototype.loadDropdown = function () {
        this.docTypes = this.template.getDropdown();
    };
    SearchComponent.prototype.pageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.currentPage));
        this.tableData = [];
        this.loadData(params);
        this.canDownloadXml = false;
        // this.canDownloadCSV = false;
        this.canDeleteInvoice = false;
        this.canSendEmail = false;
        this.canDeleteTaxDocument = false;
    };
    SearchComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    SearchComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    SearchComponent.prototype.clearSearch = function () {
        this.selectedType = null;
        this.inputText = null;
        this.selectedCompany = null;
        this.selectedHomeproGroup = null;
        this.branch = null;
        this.documentType = null;
        this.allDocType = true;
        this.allBranch = true;
        this.selectedBranch = null;
        this.selectedRdDocumentType = null;
        this.buyerNameText = null;
        this.buyerTaxID = null;
        this.selectedStatus = null;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.canDownloadXml = false;
        this.canDownloadCSV = false;
        this.canDeleteInvoice = false;
        this.canDeleteTaxDocument = false;
        this.canSendEmail = false;
        this.countNonOther = 0;
        this.countOther = 0;
        this.searchButtonClicked();
    };
    SearchComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.countNonOther = 0;
        this.countOther = 0;
        this.sortBy = null;
        this.sortMode = null;
        this.disableButton();
        this.loadData();
    };
    SearchComponent.prototype.disableButton = function () {
        this.canSendEmail = false;
        this.canDownloadXml = false;
        // this.canDownloadCSV = false;
        this.canDeleteInvoice = false;
        this.canDeleteTaxDocument = false;
    };
    SearchComponent.prototype.loadData = function (params) {
        var _this = this;
        this.checkCondition();
        if (this.errorMsg.length > 0) {
            return;
        }
        this.allBranchSelected = [];
        this.allDocumentType = [];
        _.forEach(this.branch, function (obj) {
            // this.allBranchSelected = [];
            _this.allBranchSelected.push(_.toNumber(obj.id));
        });
        _.forEach(this.documentType, function (obj) {
            // this.allDocumentType = [];
            _this.allDocumentType.push(_.toNumber(obj.id));
        });
        var data = {
            rd_doc_type: this.selectedRdDocumentType,
            search_box: this.inputText,
            buyer_tax_id: this.buyerTaxID,
            buyer_name: this.buyerNameText,
            header_issue_date_start: this.startDate == null ? this.startDate : moment(this.startDate).format('YYYY-MM-DD'),
            header_issue_date_end: this.endDate == null ? this.endDate : moment(this.endDate).format('YYYY-MM-DD'),
            group_id: this.selectedHomeproGroup,
            company_id: this.selectedCompany,
            document_type_id: _.isNil(this.documentType)
                ? this.documentType
                : _.uniq(this.allDocumentType),
            // branch_id: (_.isNil(this.branch)) ? this.branch : _.uniq(this.allBranchSelected),
            branch_id: this.selectedBranch ? [this.selectedBranch] : null,
            items_per_page: this.itemsPerPage,
            status: this.selectedStatus,
            location: this.selectedLocation,
            overdue_status: this.selectedOverdueStatus
        };
        if (this.sortBy && this.sortMode) {
            data['sort'] = this.sortBy;
            data['sort_type'] = this.sortMode;
        }
        this.loading = true;
        this.subs.add(this.apiService.postSearch(data, params).subscribe(function (res) {
            _this.tableData = res.results;
            _this.totalItems = res.count;
            _this.selectedValues = [];
            for (var i = 0; i < _this.tableData.length; i++) {
                _this.selectedValues.push(false);
            }
            _this.loading = false;
        }));
    };
    SearchComponent.prototype.loadLocationName = function () {
        var _this = this;
        this.locationSearch = [
            {
                label: 'ทั้งหมด',
                value: null
            }
        ];
        this.subs.add(this.apiService.getLocationName().subscribe(function (res) {
            _.forEach(res.results, function (obj) {
                _this.locationSearch.push({
                    label: obj.location_name,
                    value: obj.location_name
                });
            });
        }));
    };
    SearchComponent.prototype.dropdownStatus = function () {
        this.selectedStatus = null;
        this.loadLocationName();
        this.statusSearch = [
            {
                label: 'ทั้งหมด',
                value: null
            },
            {
                label: 'ชำระครบหมดแล้ว',
                value: 'full_payment'
            },
            {
                label: 'ชำระแล้วบางส่วน',
                value: 'partial_payment'
            },
            {
                label: 'ค้างชำระเต็มจำนวน',
                value: 'full_amount_owed'
            },
            {
                label: 'ไม่มีการแสดงสถานะ',
                value: 'no_payment_status_or_cancelled'
            }
        ];
        this.overdueStatusSearch = [
            {
                label: 'ทั้งหมด',
                value: null
            }, {
                label: 'Not overdue',
                value: 'Not overdue'
            }, {
                label: 'Paid',
                value: 'Paid'
            }, {
                label: '1-5 Days',
                value: '1-5 Days'
            }, {
                label: '6-30 Days',
                value: '6-30 Days'
            }, {
                label: '31-60 Days',
                value: '31-60 Days'
            }, {
                label: '61-90 Days',
                value: '61-90 Days'
            }, {
                label: '90+ Days',
                value: '90+ Days'
            },
        ];
    };
    SearchComponent.prototype.DownloadSelected = function (content, doc_type) {
        this.tableArray = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i] || this.tableData[i].status === 'cancelled') {
                continue;
            }
            // skip if rd_document_type is `other`
            if (this.tableData[i].rd_document_type === 'other' && doc_type === 'xml') {
                continue;
            }
            this.tableArray.push(this.tableData[i]);
        }
        if (!_.isEmpty(this.tableArray)) {
            this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false });
            this.allZipCount = this.tableArray.length;
            this.cancel_loading_all_zip = false;
            if (doc_type === 'xml') {
                this.download(0, this.tableArray, 'xml_file');
                this.sniff('DOWNLOAD_XML', '');
            }
            else {
                this.download(0, this.tableArray, 'pdf_file');
                this.sniff('DOWNLOAD_PDF', '');
            }
        }
    };
    SearchComponent.prototype.DeleteSelected = function (content, isInvoice) {
        if (isInvoice === void 0) { isInvoice = true; }
        this.tableArray = [];
        this.tableArray = this.selectedDocuments(isInvoice);
        if (!_.isEmpty(this.tableArray)) {
            this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false });
            this.allZipCount = this.tableArray.length;
            this.cancel_loading_all_zip = false;
            this.delete(0, this.tableArray, 'pdf_file');
            // this.sniff('DELETE_INVOICE', '')
        }
    };
    SearchComponent.prototype.selectedDocuments = function (isInvoice) {
        var _this = this;
        return this.selectedValues
            .map(function (value, index) {
            if (!value)
                return null;
            var documentType = _this.tableData[index].rd_document_type;
            if (isInvoice && documentType === 'other') {
                return _this.tableData[index];
            }
            else if (!isInvoice && documentType !== 'other') {
                var data = _this.tableData[index];
                data.version = 2;
                return data;
            }
            return null;
        })
            .filter(function (item) { return item !== null; });
    };
    SearchComponent.prototype.delete = function (index, tableArray, url_field_name) {
        var _this = this;
        this.loading_all_zip = true;
        if (index >= tableArray.length) {
            this.loading_all_zip = false;
            this.loading_all_zip_message =
                'Delete เสร็จสมบูรณ์ (ทั้งหมด ' + tableArray.length + ' รายการ)';
            return;
        }
        if (this.cancel_loading_all_zip) {
            return;
        }
        var delete_url = tableArray[index][url_field_name];
        // skip if delete url is empty.
        if (delete_url == null || delete_url.length === 0) {
            this.delete(index + 1, tableArray, url_field_name);
            return;
        }
        this.subs.add(this.apiService.deleteFileFromMediaPath(tableArray[index]).subscribe(function (obj) {
            if (_this.cancel_loading_all_zip) {
                return;
            }
            // this.loading_all_zip = false;
            var filename = _this.getFileName(tableArray[index]);
            if (url_field_name === 'xml_file') {
                filename = filename + '.xml';
            }
            else {
                filename = filename + '.pdf';
            }
            // this.apiService.createDownloadFile(obj, filename);
            _this.allZipCurrent++;
            _this.loading_all_zip_progress = (_this.allZipCurrent / _this.allZipCount) * 100;
            // data.xmlLoading = false;
            setTimeout(function () {
                _this.delete(index + 1, tableArray, url_field_name);
            }, 1000);
        }, function (error) {
            _this.loading_all_zip = false;
            _this.loading_all_zip_message = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
            // data.xmlLoading = false;
        }));
    };
    SearchComponent.prototype.canDownloadPdf = function () {
        return this.selectedValues.filter(function (select) { return select === true; }).length > 0;
    };
    SearchComponent.prototype.canDownloadCsv = function () {
        return this.selectedValues.filter(function (select) { return select === true; }).length > 0;
    };
    SearchComponent.prototype.selectIn = function (checker, data) {
        if (data.rd_document_type === 'other' && checker === true) {
            // this.canDeleteInvoice = this.selectedValues.filter(select => select === true).length > 0;
            this.countOther++;
            if (this.countOther > 0) {
                this.canDeleteInvoice = true;
                this.canSendEmail = true;
            }
            if (this.countOther > 1) {
                this.canSendEmail = false;
            }
        }
        if (data.rd_document_type === 'other' && checker === false) {
            // this.canDeleteInvoice = (data.rd_document_type === "other" && this.selectedValues.filter(select => select === true).length != 0);
            // this.canDeleteInvoice = false;
            this.countOther--;
            if (this.countOther === 0) {
                this.canDeleteInvoice = false;
                this.canSendEmail = false;
                // this.canDownloadCSV = false;
            }
            else {
                this.canSendEmail = true;
            }
        }
        if (data.rd_document_type !== 'other' && checker === true) {
            // this.canDownloadXml = this.selectedValues.filter(select => select === true).length > 0;
            this.countNonOther++;
            if (this.countNonOther > 0) {
                this.canDownloadXml = true;
                this.canSendEmail = true;
                this.canDeleteTaxDocument = true;
            }
            if (this.countNonOther > 1) {
                this.canSendEmail = false;
            }
        }
        if (data.rd_document_type !== 'other' && checker === false) {
            // this.canDownloadXml = (data.rd_document_type !== "other" && this.selectedValues.filter(select => select === true).length != 0);
            this.countNonOther--;
            if (this.countNonOther === 0) {
                this.canDownloadXml = false;
                // this.canDownloadCSV = false;
                this.canSendEmail = false;
                this.canDeleteTaxDocument = false;
            }
            else {
                this.canSendEmail = true;
            }
        }
    };
    SearchComponent.prototype.download = function (index, tableArray, url_field_name) {
        var _this = this;
        this.loading_all_zip = true;
        if (index >= tableArray.length) {
            this.loading_all_zip = false;
            this.loading_all_zip_message =
                'Download เสร็จสมบูรณ์ (ทั้งหมด ' + tableArray.length + ' รายการ)';
            return;
        }
        if (this.cancel_loading_all_zip) {
            return;
        }
        var download_url = tableArray[index][url_field_name];
        // skip if download url is empty.
        if (download_url == null || download_url.length === 0) {
            this.download(index + 1, tableArray, url_field_name);
            return;
        }
        this.subs.add(this.apiService.downloadFileFromMediaPath(download_url).subscribe(function (obj) {
            if (_this.cancel_loading_all_zip) {
                return;
            }
            // this.loading_all_zip = false;
            var filename = _this.getFileName(tableArray[index]);
            if (url_field_name === 'xml_file') {
                filename = filename + '.xml';
            }
            else {
                filename = filename + '.pdf';
            }
            _this.apiService.createDownloadFile(obj, filename);
            _this.allZipCurrent++;
            _this.loading_all_zip_progress = (_this.allZipCurrent / _this.allZipCount) * 100;
            // data.xmlLoading = false;
            setTimeout(function () {
                _this.download(index + 1, tableArray, url_field_name);
            }, 1000);
        }, function (error) {
            _this.loading_all_zip = false;
            _this.loading_all_zip_message = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
            // data.xmlLoading = false;
        }));
    };
    SearchComponent.prototype.closeDownloadAll = function () {
        this.modal.close();
        this.cancel_loading_all_zip = true;
        this.loading_all_zip = false;
        this.allZipCurrent = 0;
        this.loading_all_zip_progress = 0;
    };
    SearchComponent.prototype.getFileName = function (data) {
        var file_name = '' + data.header_invoice_number + '_' + data.rd_document_type + '_' + data.header_issue_dt;
        file_name = file_name.replace(/([^a-z0-9]+)/gi, '_');
        return file_name;
    };
    SearchComponent.prototype.selectDeselectAll = function (checked) {
        if (checked) {
            this.selectAll();
            return;
        }
        this.deselectAll();
    };
    SearchComponent.prototype.selectAll = function () {
        var _this = this;
        for (var i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].status === 'active') {
                this.canDownloadXml = this.selectedValues[i] = true;
                this.canDeleteTaxDocument = this.selectedValues[i] = true;
                // this.canDownloadCSV = this.selectedValues[i] = true;
                // this.canSendEmail = this.selectedValues[i] = true;
            }
            this.canDeleteInvoice = this.selectedValues[i] = true;
        }
        this.countOther = 0;
        this.countNonOther = 0;
        this.tableData.forEach(function (obj) {
            if (obj.rd_document_type === 'other') {
                _this.countOther++;
            }
            else {
                _this.countNonOther++;
            }
        });
    };
    SearchComponent.prototype.deselectAll = function () {
        for (var i = 0; i < this.tableData.length; i++) {
            this.canDownloadXml = this.selectedValues[i] = false;
            this.canDeleteInvoice = this.selectedValues[i] = false;
            this.canSendEmail = this.selectedValues[i] = false;
            // this.canDownloadCSV = this.selectedValues[i] = false;
        }
        this.countOther = 0;
        this.countNonOther = 0;
    };
    SearchComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = 'asc';
        }
        else {
            this.sortMode = 'desc';
        }
    };
    SearchComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    SearchComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.branch) && this.allBranch === false) {
            errorMsgList.push('สาขา');
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = 'กรุณาระบุ ' + errorMsgList.join(', ') + ' ให้ถูกต้อง';
            return;
        }
        // const dayDiff = Math.abs(moment(this.endDate).diff(moment(this.startDate), 'days'));
        // if (dayDiff > 60 && this.authService.isAccountant()) {
        //   this.errorMsg = 'ไม่สามารถเลือกระยะเวลาเกิน 60 วัน';
        // }
    };
    SearchComponent.prototype.ngOnDestroy = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.subs.unsubscribe();
    };
    SearchComponent.prototype.isAdmin = function () {
        return this.authService.isAdmin();
    };
    SearchComponent.prototype.isUIH = function () {
        return this.authService.isUIH();
    };
    SearchComponent.prototype.isAccountant = function () {
        return this.authService.isAccountant();
    };
    SearchComponent.prototype.isAccountantAdmin = function () {
        return this.authService.isAccountantAdmin();
    };
    SearchComponent.prototype.isIT = function () {
        return this.authService.isIT();
    };
    SearchComponent.prototype.isViewer = function () {
        return this.authService.isViewer();
    };
    SearchComponent.prototype.isViewerAudit = function () {
        return this.authService.isViewerAudit();
    };
    Object.defineProperty(SearchComponent.prototype, "isSystemAdmin", {
        get: function () {
            return this.authService.isSystemAdmin() || this.authService.isAdmin();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchComponent.prototype, "hasRequestDeletePermission", {
        get: function () {
            return this.authService.hasRequestDeletePermission();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchComponent.prototype, "hasRequestEditPermission", {
        get: function () {
            return this.authService.hasRequestEditPermission();
        },
        enumerable: true,
        configurable: true
    });
    SearchComponent.prototype.setDefaultCcEmail = function () {
        var _this = this;
        var _loop_1 = function (i) {
            if (!this_1.selectedValues[i]) {
                return "continue";
            }
            if (this_1.tableData[i].additional_data.first_email_notified === false
                && this_1.tableData[i].additional_data.first_sms_notified === false
                && this_1.tableData[i].additional_data.second_sms_notified === false
                && this_1.tableData[i].additional_data.second_email_notified === false) {
                this_1.ccEmail = [
                    { ccEmailList: 'pirada@chod.co.th' }
                ];
            }
            if (this_1.tableData[i].additional_data.first_email_notified === true
                && this_1.tableData[i].additional_data.first_sms_notified === true
                && this_1.tableData[i].additional_data.second_sms_notified === false
                && this_1.tableData[i].additional_data.second_email_notified === false) {
                this_1.ccEmail = [
                    { ccEmailList: 'pirada@chod.co.th' }
                ];
            }
            if (this_1.tableData[i].additional_data.first_sms_notified === false
                && this_1.tableData[i].additional_data.first_email_notified === false
                && this_1.tableData[i].additional_data.second_email_notified === true
                && this_1.tableData[i].additional_data.second_sms_notified === true
                && this_1.tableData[i].additional_data.payment_type === 'amount') {
                this_1.ccEmail = [
                    { ccEmailList: 'pirada@chod.co.th' },
                    { ccEmailList: 'admin_operation@chod.co.th' },
                ];
            }
            if (this_1.tableData[i].additional_data.first_sms_notified === true
                && this_1.tableData[i].additional_data.first_email_notified === true
                && this_1.tableData[i].additional_data.second_email_notified === true
                && this_1.tableData[i].additional_data.second_sms_notified === true
                && this_1.tableData[i].additional_data.payment_type === 'amount') {
                this_1.ccEmail = [
                    { ccEmailList: 'pirada@chod.co.th' },
                    { ccEmailList: 'admin_operation@chod.co.th' },
                ];
            }
            if (this_1.tableData[i].additional_data.first_sms_notified === false
                && this_1.tableData[i].additional_data.first_email_notified === false
                && this_1.tableData[i].additional_data.second_email_notified === true
                && this_1.tableData[i].additional_data.second_sms_notified === true
                && this_1.tableData[i].additional_data.payment_type === 'percentage') {
                this_1.ccEmail = [
                    { ccEmailList: 'pirada@chod.co.th' },
                    { ccEmailList: 'admin_operation@chod.co.th' },
                    { ccEmailList: 'ubonwan@chod.co.th' },
                ];
            }
            if (this_1.tableData[i].additional_data.first_sms_notified === true
                && this_1.tableData[i].additional_data.first_email_notified === true
                && this_1.tableData[i].additional_data.second_email_notified === true
                && this_1.tableData[i].additional_data.second_sms_notified === true
                && this_1.tableData[i].additional_data.payment_type === 'percentage') {
                this_1.ccEmail = [
                    { ccEmailList: 'pirada@chod.co.th' },
                    { ccEmailList: 'admin_operation@chod.co.th' },
                    { ccEmailList: 'ubonwan@chod.co.th' },
                ];
            }
            // Only Foodie sent first email and sms
            if (this_1.tableData[i].additional_data.first_email_notified === false
                && this_1.tableData[i].additional_data.first_sms_notified === false
                && this_1.tableData[i].additional_data.second_sms_notified === true
                && this_1.tableData[i].additional_data.second_email_notified === true
                && this_1.tableData[i].is_foodie === true) {
                this_1.ccEmail = [
                    { ccEmailList: 'pirada@chod.co.th' },
                    { ccEmailList: 'admin_operation@chod.co.th' },
                    { ccEmailList: 'ubonwan@chod.co.th' },
                    { ccEmailList: 'prissana@foodiebangna.com' },
                    { ccEmailList: 'chatanunrojwong@foodiebangna.com' },
                    { ccEmailList: 'passakorn.na@foodiebangna.com' },
                    { ccEmailList: 'suthamas.su@foodiebangna.com' }
                ];
            }
            // Only Foodie sent second email and sms
            if (this_1.tableData[i].additional_data.first_email_notified === true
                && this_1.tableData[i].additional_data.first_sms_notified === true
                && this_1.tableData[i].additional_data.second_sms_notified === true
                && this_1.tableData[i].additional_data.second_email_notified === true
                && this_1.tableData[i].is_foodie === true) {
                this_1.ccEmail = [
                    { ccEmailList: 'pirada@chod.co.th' },
                    { ccEmailList: 'admin_operation@chod.co.th' },
                    // {ccEmailList: 'ubonwan@chod.co.th'},
                    { ccEmailList: 'prissana@foodiebangna.com' },
                    { ccEmailList: 'chatanunrojwong@foodiebangna.com' },
                    { ccEmailList: 'passakorn.na@foodiebangna.com' },
                    { ccEmailList: 'suthamas.su@foodiebangna.com' }
                ];
            }
            // Percentage reminders (1st and 2nd) also CC these, except Foodie; keep in sync with PERCENT_EXTRA_CC_EMAIL
            if (this_1.tableData[i].additional_data.payment_type === 'percentage' && this_1.tableData[i].is_foodie !== true) {
                var current_1 = this_1.ccEmail.map(function (cc) { return cc.ccEmailList; });
                PERCENT_EXTRA_CC_EMAIL
                    .filter(function (email) { return !current_1.includes(email); })
                    .forEach(function (email) { return _this.ccEmail.push({ ccEmailList: email }); });
            }
        };
        var this_1 = this;
        // VERY HARD CODE DEFAULT CC PAYMENT AMOUNT AND PERCENTAGE
        // REFERENCE FROM BOOLEAN OF ADDITIONAL_DATA
        for (var i = 0; i < this.selectedValues.length; i++) {
            _loop_1(i);
        }
        // }
    };
    SearchComponent.prototype.askEmailType = function (content) {
        // REFERENCE FROM BOOLEAN OF ADDITIONAL_DATA
        this.mapPaymentType();
        this.setDefaultCcEmail();
        this.tableArray = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i]) {
                continue;
            }
            if (this.tableData[i].additional_data.first_email_notified
                && this.tableData[i].additional_data.first_sms_notified === true) {
                this.resendFirstNotify = true;
            }
            if (this.tableData[i].additional_data.second_email_notified
                && this.tableData[i].additional_data.second_sms_notified === true) {
                this.resendSecondNotify = true;
            }
        }
        this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false });
    };
    SearchComponent.prototype.closeAskEmailTypeModal = function () {
        this.modal.close();
        this.ccEmail = [];
        this.buyerEmail = [{ value: '' }];
        this.remark = null;
        this.resendFirstNotify = false;
        this.resendSecondNotify = false;
    };
    SearchComponent.prototype.mapPaymentType = function () {
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i]) {
                continue;
            }
            this.paymentType = this.tableData[i].additional_data.payment_type;
        }
    };
    SearchComponent.prototype.sendEmailSelected = function (content, overdue) {
        var _this = this;
        this.tableArray = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i]) {
                continue;
            }
            this.tableArray.push(this.tableData[i].id);
        }
        this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false });
        this.isLoadingMessage = 'โปรดรอสักครู่';
        this.isSending = true;
        var data = {
            tax_data_id_list: this.tableArray,
            overdue: overdue,
        };
        this.subs.add(this.apiService.resendEmailSms(data).subscribe(function (result) {
            _this.isSending = false;
            _this.resendEmailSmsMessage = 'ส่ง E-mail และ SMS สำเร็จแล้ว';
            _this.remark = result;
            _this.sniff('SEND_EMAIL_AND_SMS', '');
        }, function (error) {
            _this.isSending = false;
            _this.resendEmailSmsMessage = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง';
        }));
    };
    SearchComponent.prototype.resendEmailSelected = function (content, resend) {
        var _this = this;
        // map default cc email and buyeremail to send api
        this.tableArray = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i]) {
                continue;
            }
            this.tableArray.push(_.toNumber(this.tableData[i].id));
        }
        this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false });
        this.isLoadingMessageResend = 'โปรดรอสักครู่';
        this.ccEmailcheckList = [];
        this.buyerEmailCheckList = [];
        this.buyerEmail.map(function (res) {
            _this.buyerEmailCheckList.push(res.value);
            if (res.value === '') {
                return _this.buyerEmailCheckList = [];
            }
        });
        this.ccEmail.map(function (res) {
            _this.ccEmailcheckList.push(res.ccEmailList);
        });
        this.isResend = true;
        this.resendFirst = true;
        this.resendSecond = resend;
        var data = {
            tax_data_id: this.tableArray,
            is_resend: this.isResend,
            resend_first: this.resendFirst !== this.resendSecond ? this.resendSecond = false : this.resendFirst === true,
            resend_second: !this.resendSecond,
            buyer_email: this.buyerEmailCheckList,
            cc_email: this.ccEmailcheckList
        };
        this.subs.add(this.apiService.resendEmailSmsNotify(data).subscribe(function () {
            _this.isResend = false;
            _this.resendEmailSmsMessage = 'ส่ง E-mail และ SMS สำเร็จแล้ว';
        }, function (error) {
            _this.isResend = false;
            _this.resendEmailSmsMessage = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง';
        }));
    };
    SearchComponent.prototype.closeSendEmailSmsModal = function () {
        this.modal.close();
        this.remark = null;
    };
    SearchComponent.prototype.addDetailEmail = function () {
        this.buyerEmail.push({ value: '' });
    };
    SearchComponent.prototype.removeDetailEmail = function () {
        this.buyerEmail.pop();
    };
    SearchComponent.prototype.openOverdueNotification = function (content, data) {
        // REFERENCE FROM BOOLEAN OF ADDITIONAL_DATA
        this.paymentType = [];
        this.paymentType = data.additional_data.payment_type;
        this.additionalDownloadPdf = data.additional_data.invoice_payment_pdf_file;
        if (data.additional_data.first_email_notified === true) {
            this.firstEmailNotify = true;
        }
        if (data.additional_data.first_sms_notified === true) {
            this.firstSmsNotify = true;
        }
        if (data.additional_data.second_email_notified === true) {
            this.secondEmailNotify = true;
        }
        if (data.additional_data.second_email_notified === true) {
            this.secondSmsNotify = true;
        }
        if (this.firstEmailNotify && this.firstSmsNotify && this.secondEmailNotify &&
            this.secondSmsNotify === true) {
            this.canDownloadInvoicePdf = true;
        }
        if (this.additionalDownloadPdf === '') {
            this.canDownloadInvoicePdf = false;
        }
        if (data.additional_data.overdue_balance === 0) {
            this.canDownloadInvoicePdf = false;
        }
        this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false });
    };
    SearchComponent.prototype.closeOverdueNotification = function () {
        this.modal.close();
        this.firstEmailNotify = false;
        this.firstSmsNotify = false;
        this.secondEmailNotify = false;
        this.secondSmsNotify = false;
        this.additionalDownloadPdf = null;
        this.canDownloadInvoicePdf = false;
    };
    SearchComponent.prototype.openCommentBox = function (taxData, content) {
        this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false });
        this.taxId = taxData.id;
        this.getCommentList();
    };
    SearchComponent.prototype.getCommentList = function () {
        var _this = this;
        var params = new HttpParams()
            .set('tax_data', this.taxId)
            .set('none_pagination', 'true');
        this.subs.add(this.apiService.getCommentList(params).subscribe(function (comments) {
            _this.commentList = comments;
            _this.showResult = true;
            _this.sniff('GET_COMMENT', '');
        }));
    };
    SearchComponent.prototype.addComment = function (newComment) {
        var _this = this;
        // from memo comment
        if (newComment[0].newComment == null || newComment[0].newComment.trim().length === 0) {
            return;
        }
        var profileUser = (localStorage.getItem('username'));
        var fd = {
            'tax_data': this.taxId,
            'message': newComment[0].newComment || '',
            'created_username': profileUser.toString(),
        };
        this.apiService.createNewComment(fd).subscribe(function (comment) {
            _this.commentList.push(comment);
            newComment = [];
        });
    };
    SearchComponent.prototype.isOwner = function (stream) {
        return this.owner === stream.created_username;
    };
    SearchComponent.prototype.deleteComment = function (commentId) {
        var _this = this;
        // from memo comment
        this.apiService.deleteComment(commentId).subscribe(function () { return (_this.commentList = _this.commentList.filter(function (stream) { return stream.id !== commentId; })); });
    };
    SearchComponent.prototype.downloadCsvReport = function (content) {
        var _this = this;
        this.tableArray = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i]) {
                continue;
            }
            this.tableArray.push(this.tableData[i].id);
        }
        var data = {
            tax_id: this.tableArray,
            company_id: this.selectedCompany,
            rd_doc_type: this.selectedRdDocumentType,
            doc_no: this.inputText,
            buyer_tax_id: this.buyerTaxID,
            buyer_name: this.buyerNameText,
            header_issue_date_start: this.startDate == null ? this.startDate : moment(this.startDate).format('YYYY-MM-DD'),
            header_issue_date_end: this.endDate == null ? this.endDate : moment(this.endDate).format('YYYY-MM-DD'),
            document_type_id: _.isNil(this.documentType)
                ? this.documentType
                : _.uniq(this.allDocumentType),
            // branch_id: (_.isNil(this.branch)) ? this.branch : _.uniq(this.allBranchSelected),
            status: this.selectedStatus,
            location: this.selectedLocation,
            overdue_status: this.selectedOverdueStatus
        };
        this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false });
        this.isLoadingCsv = true;
        this.loadingCsvMessage = 'กำลังดาวน์โหลดไฟล์ CSV';
        this.countCsvFile = this.tableArray.length;
        this.subs.add(this.apiService.exportCsvReport(data).subscribe(function (res) {
            var filename = 'csv-' + moment().format('DD-MM-YYYY');
            _this.apiService.createDownloadFile(res, filename);
            _this.isLoadingCsv = false;
            _this.loadingCsvMessage = 'ดาวน์โหลดไฟล์ CSV เสร็จสิ้น';
            _this.sniff('DOWNLOAD_CSV', filename);
        }));
    };
    SearchComponent.prototype.downloadAdditionalPdf = function () {
        var _this = this;
        var download_url = this.additionalDownloadPdf;
        this.subs.add(this.apiService.downloadFileFromMediaPath(download_url).subscribe(function (pdf) {
            var filename = 'แจ้งเตือนชำระหนี้ค้าง.pdf';
            _this.apiService.createDownloadFile(pdf, filename);
        }));
    };
    SearchComponent.prototype.getDeleteMessageConfirm = function (request) {
        if (request === void 0) { request = false; }
        this.tableArray = [];
        this.tableArray = this.selectedDocuments(false);
        var documentNumbers = this.tableArray.map(function (item) { return item.header_invoice_number + " (\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17 " + item.corporate_branch__corporate__name + ")"; });
        return request
            ? 'คุณแน่ใจหรือไม่ที่จะขอลบเอกสารฉบับนี้<br>* ' + documentNumbers.join('<br>* ')
            : 'คุณแน่ใจหรือไม่ที่จะลบเอกสารฉบับนี้<br>* ' + documentNumbers.join('<br>* ');
    };
    SearchComponent.prototype.RequestDeleteSelected = function () {
        var _this = this;
        var taxDataId = this.selectedDocuments(false).map(function (item) { return item.id; });
        var payload = {
            tax_data: taxDataId,
            request_type: 'delete_document',
        };
        this.apiService.createDocumentRequest(payload).pipe(finalize(function () {
            _this.loading_all_zip = false;
            _this.modal = _this.modalService.open(_this.resultContentModal);
        })).subscribe(function () {
            _this.loading_all_zip_message = 'ส่งคำขอสำเร็จ';
        }, function (error) {
            _this.loading_all_zip_message = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
        });
    };
    SearchComponent.prototype.openEditDocumentModal = function (contentModal, data) {
        this.selectedDocument = data;
        this.statusBefore = this.statusChoices.find(function (item) { return item.value === data.additional_data.status; }).label || 'ไม่มีการแสดงสถานะ';
        this.amountAfter = data.additional_data.overdue_balance.toString();
        this.statusAfter = data.additional_data.status !== 'full_payment' ? data.additional_data.status : '';
        this.modal = this.modalService.open(contentModal, {
            centered: true,
            size: 'lg'
        });
    };
    SearchComponent.prototype.validDecimal = function (input) {
        if (!input) {
            return false;
        }
        var isDecimalOrThousandSeparated = input.match(/^\d{1,3}(,\d{3})*(\.\d+)?$/);
        var isNormalNumber = input.match(/^\d+(\.\d+)?$/);
        return isDecimalOrThousandSeparated !== null || isNormalNumber !== null;
    };
    SearchComponent.prototype.validAmountAfterAndStatusAfter = function (amountAfter, statusAfter) {
        if (!statusAfter) {
            return true;
        }
        if (statusAfter === 'full_payment' && amountAfter !== '0') {
            return false;
        }
        return true;
    };
    Object.defineProperty(SearchComponent.prototype, "validEditDocumentForm", {
        get: function () {
            if (!this.selectedDocument) {
                return false;
            }
            if (!this.amountAfter && !this.statusAfter) {
                return false;
            }
            if (this.amountAfter && !this.validDecimal(this.amountAfter)) {
                return false;
            }
            if (!this.validAmountAfterAndStatusAfter(this.amountAfter, this.statusAfter)) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    SearchComponent.prototype.editDocument = function () {
        var _this = this;
        var payload = {
            tax_data: this.selectedDocument.id,
            amount_before: this.selectedDocument.additional_data.overdue_balance,
            amount_after: this.amountAfter ? this.amountAfter.replace(/,/g, '').replace(/ /g, '') : '',
            status_before: this.selectedDocument.additional_data.status,
            status_after: this.statusAfter || '',
        };
        this.apiService.editDocument(payload).pipe(finalize(function () {
            _this.loading_all_zip = false;
            _this.modal = _this.modalService.open(_this.resultContentModal, {
                centered: true,
            });
        })).subscribe(function () {
            _this.closeModal();
            _this.loading_all_zip_message = 'แก้ไขสำเร็จ';
        }, function (error) {
            _this.closeModal();
            _this.loading_all_zip_message = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
        });
    };
    SearchComponent.prototype.requestEditDocument = function () {
        var _this = this;
        var payload = {
            tax_data: [this.selectedDocument.id],
            request_type: 'edit_document',
            details: {
                amount_before: this.selectedDocument.additional_data.overdue_balance,
                amount_after: this.amountAfter ? this.amountAfter.replace(/,/g, '').replace(/ /g, '') : '',
                status_before: this.selectedDocument.additional_data.status,
                status_after: this.statusAfter || '',
            }
        };
        this.apiService.createDocumentRequest(payload).pipe(finalize(function () {
            _this.loading_all_zip = false;
            _this.modal = _this.modalService.open(_this.resultContentModal, {
                centered: true,
            });
        })).subscribe(function () {
            _this.closeModal();
            _this.loading_all_zip_message = 'ส่งคำขอสำเร็จ';
        }, function (error) {
            _this.closeModal();
            _this.loading_all_zip_message = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
        });
    };
    SearchComponent.prototype.closeModal = function () {
        this.modal.close();
        this.closeConfirmModal();
        this.amountAfter = undefined;
        this.statusAfter = undefined;
        this.selectedDocument = undefined;
        this.clickedSubmit = false;
    };
    SearchComponent.prototype.openConfirmModal = function (contentModal) {
        this.clickedSubmit = true;
        if (!this.validEditDocumentForm) {
            return;
        }
        this.confirmModal = this.modalService.open(contentModal, {
            centered: true,
        });
    };
    SearchComponent.prototype.closeConfirmModal = function () {
        this.confirmModal.close();
    };
    SearchComponent.prototype.sniff = function (action, detail) {
        var data = {
            action: action,
            feature: 'DOCUMENT_SEARCH',
            detail: detail
        };
        this.apiService.sniff(data).subscribe();
    };
    return SearchComponent;
}());
export { SearchComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search.component.ts.pre-build-optimizer.js